// JQuery Libraries
window.jQuery = window.$ = require('jquery');
require('velocity-animate');
require('selectize');
require('blueimp-file-upload');

// Bootstrap Libraries
require('bootstrap');
require('bootstrap-tour');
require('bootstrap-datepicker');
require('bootstrap-3-typeahead');

window._ = require('lodash');
window.Backbone = require('backbone');
window.Marionette = require('backbone.marionette');
// NOTE: compile template using lodash4 so we can use it in jade files
window.Marionette.TemplateCache.prototype.compileTemplate = function (rawTemplate, options) {
    return window._.template(rawTemplate, options);
};
window.Marionette.Dashboard = require('../marionette.dashboard/src/build/core.js');
window.diff_match_patch = require('diff-match-patch');
window.moment = require('moment');
window.moment.updateLocale('en', {
    monthsShort: [
        'Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.',
        'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'
    ]
});

require('moment/min/locales.js');
require('moment-timezone');
window.lazyload = require('vanilla-lazyload');
window.Pikaday = require('pikaday');
window.NumberToWords = require('number-to-words');
window.s = require('underscore.string');
window.sprintf = require('sprintf-js').sprintf;
window.d3 = require('d3');
window.object_hash = require('object-hash');
window.sortable = require('html5sortable');
